export default __webpack_public_path__ + "static/media/coq-1.4d12348e.jpg";